"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepMergeHTMLProps = void 0;
exports.deepMergeHTMLProps = (mainProps, secondaryProps) => {
    const newProps = Object.assign({}, mainProps);
    for (const key in secondaryProps) {
        const secondaryVal = secondaryProps[key];
        if (!newProps[key]) {
            newProps[key] = secondaryVal;
            continue;
        }
        if (key === "className") {
            newProps[key] += " " + secondaryVal;
            continue;
        }
        if (key === "style") {
            newProps[key] = Object.assign(Object.assign({}, secondaryVal), newProps[key]);
        }
        if (typeof newProps[key] === "function" &&
            typeof secondaryVal === "function") {
            // function
            const fn1 = newProps[key];
            const fn2 = secondaryVal;
            newProps[key] = (...args) => {
                fn1(...args);
                fn2(...args);
            };
        }
    }
    return newProps;
};
